import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { LanguageService } from 'app/core/language/language.service';
import {
    AppLanguage,
    AppLanguageOption,
} from 'app/core/language/language.types';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'languages',
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule,
        NgTemplateOutlet,
        TranslocoPipe,
    ],
    //Sem escolha a oferecer, o elemento fica oculto e some também do
    //espaçamento (space-x) de quem o contém, como no cabeçalho do classy.
    host: { '[attr.hidden]': 'selectable ? null : ""' },
})
export class LanguagesComponent {
    //Falso com um idioma só liberado (produção, por enquanto) ou com o
    //armazenamento do navegador bloqueado.
    selectable: boolean;
    languages: AppLanguageOption[];
    active: AppLanguageOption;

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _languageService: LanguageService
    ) {
        this.selectable = this._languageService.selectable;
        this.languages = this._languageService.languages;
        this.active = this._languageService.active;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param lang
     */
    setActiveLang(lang: AppLanguage): void {
        if (lang === this.active.id) {
            return;
        }

        this._authService.changeLanguage(lang);
    }
}
